import { FaPenToSquare, FaQrcode, FaRightFromBracket, FaTrashCan } from "react-icons/fa6";
import { WaTableActionBtn } from "./action_button";

export const WaTableActionGroup = ({ item, handleOpenScan, handleOpenUpdate, handleOpenLogout, handleOpenDelete }) => {
    const isConnected = item?.status === "Connected";
    return (
        <div className="grid grid-cols-4 gap-1 w-full">
            {/* Slot 1: Scan */}
            {/* {item?.is_active == false && ( */}
                <WaTableActionBtn
                    icon={FaQrcode}
                    label={isConnected ? "Scan Ulang" : "Scan"}
                    color={isConnected ? "amber" : "cyan"}
                    onClick={handleOpenScan}
                />
            {/* )} */}

            {/* Slot 2: Update */}
            <WaTableActionBtn
                icon={FaPenToSquare}
                label="Update"
                color="blue"
                onClick={handleOpenUpdate}
            />

            {/* Slot 3: Logout / Placeholder */}
            {isConnected ? (
                <WaTableActionBtn
                    icon={FaRightFromBracket}
                    label="Logout"
                    color="amber"
                    onClick={handleOpenLogout}
                />
            ) : (
                <div />
            )}

            {/* Slot 4: Hapus — selalu tampil */}
            <WaTableActionBtn
                icon={FaTrashCan}
                label="Hapus"
                color="slate"
                onClick={() => handleOpenDelete(item)}
            />
        </div>
    );
};